<template>
  <!-- v1 -->
  <div v-if="content">
    <template v-if="!advancedPolicy">
      <el-button
          @click="content.push([])"
          icon="el-icon-plus">Policy group
      </el-button>

      <el-row
          v-for="(policiesGroup,idx) in content"
          :key="idx"
          type="flex">
        <el-col :span="22">

          <el-select
              v-model="content[idx]"
              multiple
              style="width: 100%" @change="$emit('input', outgoing)" clearable filterable>
            <el-option
                v-for="(policy,pK) in ruleMatchPolicies"
                :key="pK"
                :label="policy"
                :value="pK"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button
              icon="el-icon-minus"
              @click="content.splice(idx,1);$emit('input', outgoing)"></el-button>
        </el-col>
      </el-row>
    </template>
    <el-row v-else>

      <el-select
          v-model="content"
          multiple
          style="width: 100%" @change="$emit('input', outgoing)" clearable filterable>
        <el-option
            v-for="(policy,pK) in ruleMatchPolicies"
            :key="pK"
            :label="policy"
            :value="pK"></el-option>
      </el-select>
    </el-row>
  </div>
</template>

<script>
import * as moment from "moment";

export default {
  name: "PoliciesEditor",

  props: {
    advancedPolicy: {type: Boolean, default: false},
    value: {default: null},

  },
  data() {
    return {
      content: null,

    };
  },
  computed: {
    ruleMatchPolicies() {
      if (this.advancedPolicy)
        return {
          discountFactor: 'Discount %',
          timerange: 'Time Period',
          vehicleTypes: 'V. Types',
          vgroup: 'V. Group',
          langPattern: 'Lang match',
          TripService: 'Service',
          insurance: 'Insurance',
          locs: 'Locations',
          allLocations: 'All Locations check',
          pax_range: 'Pax range',
          days_range: 'Days range',
          adultPrice: 'Adult Price',
          kidPrice: 'Kid Price',
          routePrice: 'Fixed Price',
          appliedPercent: 'Apply % on total',
          percentPrice: 'Value is percent'
        }
      return {
        // USE_FIELDS: 'USE SPECIFIC FIELDS',
        PAX_EXACT: 'PAX_EXACT',
        FIX_PRICE_BY_PAX: 'FIX_PRICE_BY_PAX',
        FIX_KIDS_HALF_PRICE_BY_PAX: 'FIX_KIDS_HALF_PRICE_BY_PAX',
        PAX_RANGE: 'PAX_RANGE',
        INCLUDE_LOC: 'INCLUDE_LOC',
        INCLUDE_LOC_BY_CO: 'INCLUDE_LOC_BY_CO',
        IS_RUTE: 'IS_RUTE',
        TRANS_TYPE_IS_DISTRIBUTOR: 'TRANS_TYPE_IS_DISTRIBUTOR',
        LOC_IN_GROUP: 'LOC_IN_GROUP',
        CLOSEST_RUTE: 'CLOSEST_RUTE',
        TRIP_SPECIFIC: 'TRIP_SPECIFIC',
        PRICE_PER_DAY: 'PRICE_PER_DAY',
        CHECK_PRODUCT: 'CHECK_PRODUCT',
        RUTE: 'RUTE',
        IS_VEHICLE: 'IS_VEHICLE',
        IS_VEHICLE_TYPE: 'IS_VEHICLE_TYPE',
        SPCF_VEHICLE: 'SPCF_VEHICLE',
        BOOKING_SPECIFIC: 'BOOKING_SPECIFIC',
        NO_SERVISE_SPECIFIED: 'NO_SERVISE_SPECIFIED',
        CATCH_ALL: 'CATCH_ALL',
        BEST_MATCH: 'BEST_MATCH',
      }
    },
    outgoing() {
      if (!this.content) return null
      if (this.advancedPolicy) return this.content.join(',')
      let out = []
      this.content.forEach(policies => out.push(policies.join(',')))
      return out.join('||');
    },
    incoming() {
      if (!this.value) return
      if (this.advancedPolicy) return _.isArray(this.value) ? this.value : this.value.split(',')
      let incoming = []
      this.value.split('||')
          .forEach(group => incoming.push([...group.split(',')]))
      return incoming;
    }
  },
  methods: {
    removePolicy(groupIdx, policyIdx) {
      const pG = this.content[groupIdx]
      pG.splice(policyIdx, 1)
      if (!pG.length)
        this.content.splice(groupIdx, 1)
      this.$emit('input', this.outgoing)
    }
  },
  created() {
    _log_("chll..clk...", this.value, this.incoming);
    this.content = this.incoming || []

  },
};
</script>
<style>
.hover-redirect {
  z-index: 20;
  position: absolute;
  left: 2px;
  top: 2px;
}
</style>
